// Règles commerciales partagées — doivent rester alignées sur backend/server.py
// (FREE_SHIPPING_THRESHOLD) ; tarifs par zone dans shippingCountries.json.
import shippingConfig from './shippingCountries.json';

export const FREE_SHIPPING_THRESHOLD = 59;
// Estimation du panier, avant le choix du pays : tarif France.
export const SHIPPING_FLAT_RATE = shippingConfig.rates.FR;

// Sur mesure fermé au lancement. Pour le rouvrir : REACT_APP_CUSTOM_ORDERS_ENABLED=true
// au build (variable Railway), avec CUSTOM_ORDERS_ENABLED=true côté serveur.
export const CUSTOM_ORDERS_ENABLED = process.env.REACT_APP_CUSTOM_ORDERS_ENABLED === 'true';

// Les descriptions en base finissent par « Sur mesure, choisissez… » : ce passage est masqué
// tant que le sur mesure est fermé, sans toucher aux textes saisis dans l'admin.
export function publicDescription(text) {
  if (CUSTOM_ORDERS_ENABLED || !text) return text;
  return text.split(/\s+(?=Sur mesure,|Made to order,)/)[0];
}
// Forfait sur mesure par défaut, si le produit ne porte pas son propre custom_price.
export const DEFAULT_CUSTOM_PRICE = 45;

// Prix ronds, sans décimales inutiles (30 €, pas 30.00 €).
export function formatPrice(value) {
  if (typeof value !== 'number') return '';
  return `${Number.isInteger(value) ? value : value.toFixed(2)} €`;
}
